import SiteHeader from "@/pages/home/components/SiteHeader";
import HeroSection from "@/pages/home/components/HeroSection";
import CirclesSection from "@/pages/home/components/CirclesSection";
import TagsSection from "@/pages/home/components/TagsSection";
import GroupsSection from "@/pages/home/components/GroupsSection";
import TimelineSection from "@/pages/home/components/TimelineSection";
import ZonesSection from "@/pages/home/components/ZonesSection";
import DownloadCta from "@/pages/home/components/DownloadCta";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <HeroSection />
        <CirclesSection />
        <TagsSection />
        <GroupsSection />
        <TimelineSection />
        <ZonesSection />
        <DownloadCta />
      </main>
      <SiteFooter />
    </div>
  );
}